import { ReactComponent as Logo } from "../assets/wingstop-x-fs__logo.svg";
import { SocialShare } from "./SocialShare";
import { Order } from "./Order";

export const Header = () => {
  return (
    <div className="header">
      <div className="container">
        <Logo className="headerLogo" />
        <div className="orderSocialContainer">
          <Order />
          <SocialShare />
        </div>
      </div>
    </div>
  );
};
